import styled from 'styled-components';
import React from 'react';

const Hover = styled.div`
    position: relative;
`;

// being used
let manageSpacingEnd = () => {};

const BuilderSection = (props) => {
    const { className = '', item } = props;
    const dorikClass = className.split(' ')[0];
    // const { margin } = style || {};
    // const marginSt = styleCombinator("margin", margin);

    // const manageSpacingStart = (address, name, direction, startPosition) => {
    //     return endPosition => {
    //         if (direction === "top" || direction === "left") {
    //             const increaseBy = endPosition - startPosition;
    //             if (name === "margin") {
    //                 const newData =
    //                     parseInt(marginSt.marginTop) + increaseBy + "px";
    //                 props.updateSpacing(address, name, direction, newData);
    //             }
    //         }
    //     };
    // };

    return (
        <Hover className={`dorik-section ${className}`}>
            {item.frames &&
                Object.entries(item.frames)
                    .filter(([_, v]) => v.frameId)
                    .map(([position]) => (
                        <div
                            key={position}
                            className={`${dorikClass}-frame-${position} dorik-frame-${position}`}
                        />
                    ))}

            {props.children}
        </Hover>
    );
};

export default React.memo(BuilderSection);
